import React from "react";
import { Route, Routes } from "react-router-dom";
import PickRoute from "./pick-route";
import ProductData from "./product-data";

const Warehouse = () => {
  return (
    <Routes>
      <Route path="pick-route" element={<PickRoute />} />
      <Route path="product-data" element={<ProductData />} />
    </Routes>
  );
};

export default Warehouse;
